import React from 'react';
import { Row, Button } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

import CustomInput from '../../../common/formitems/input';
import _ from 'lodash';
import moment from 'moment';

// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;

const FormTipoSello = props => {
  const handleSubmit = e => {
    e.preventDefault();
    props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log("Received values of form: ", values);
        props.onSubmit({
          nombre: values.nombre,
          valor: values.valor,
          vigenteDesde: values.vigenteDesde.toDate(),
          vigenteHasta: values.vigenteHasta.toDate(),
        });
      }
    });
  };

  const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 16,
        offset: 8,
      },
    },
  };

  return (
    <div>
      <h1 className="tituloForm">Datos del Tipo de Sello</h1>

      <Form onSubmit={handleSubmit} layout={'vertical'}>
        <Row gutter={16}>
          <CustomInput
            tooltip={'Nombre de la tasa de justicia'}
            type={'input'}
            name={'nombre'}
            form={props.form}
            label={'Nombre de la Tasa'}
            required={true}
            initialValue={_.get(props, 'datos.nombre', '')}
            message={'Por favor, ingrese el nombre de la tasa'}
            min={0}
            style={{ width: '80%' }}
            offset={4}
            span={8}
          />

          <CustomInput
            tooltip={'Valor en pesos de la tasa de justicia'}
            type={'number'}
            name={'valor'}
            form={props.form}
            label={'Valor de la Tasa'}
            required={true}
            initialValue={_.get(props, 'datos.valor', 0)}
            message={'Por favor, ingrese el valor de la tasa'}
            min={0}
            style={{ width: '80%' }}
            span={8}
          />
        </Row>

        <Row gutter={16}>
          <CustomInput
            tooltip={'Fecha de inicio de vigencia de la tasa'}
            type={'date'}
            format={'DD/MM/YYYY'}
            name={'vigenteDesde'}
            form={props.form}
            label={'Vigente Desde'}
            required={true}
            initialValue={
              props.datos.vigenteDesde
                ? moment(props.datos.vigenteDesde, 'DD/MM/YYYY')
                : null
            }
            message={'Por favor, ingrese la fecha de inicio de vigencia'}
            style={{ width: '80%' }}
            offset={4}
            span={8}
          />

          <CustomInput
            tooltip={'Fecha de fin de vigencia de la tasa'}
            type={'date'}
            format={'DD/MM/YYYY'}
            name={'vigenteHasta'}
            form={props.form}
            label={'Vigente Hasta'}
            required={true}
            initialValue={
              props.datos.vigenteHasta
                ? moment(props.datos.vigenteHasta, 'DD/MM/YYYY')
                : null
            }
            message={'Por favor, ingrese la fecha de fin de vigencia'}
            style={{ width: '80%' }}
            span={8}
          />
        </Row>

        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            <span>
              <Icons.SaveOutlined />
              Siguiente
            </span>
          </Button>
        </FormItem>
      </Form>
    </div>
  );
};

export default Form.create({})(FormTipoSello);
